import { useQuery } from '@tanstack/react-query';
import { useCampaigns } from '@/hooks/use-campaigns';
import { useTenant } from '@/hooks/use-tenant';
import {
  campaignOrdersChartQuery,
  campaignPerformanceQuery,
  dataSufficiencyQuery,
  tabRange,
  type AnalyticsTabParams,
} from '@/hooks/analytics/analytics-queries';

/** Queries of the Push tab, fetched only while it is open (ANLT-01). */
export function useCampaignsTabData(params: AnalyticsTabParams) {
  const tenant = useTenant();
  const range = tabRange(params);
  const { fromDate, toDate, granularity, enabled } = params;

  const campaignPerformance = useQuery({
    ...campaignPerformanceQuery(tenant.slug, range),
    enabled,
  });
  const campaignOrdersChart = useQuery({
    ...campaignOrdersChartQuery(tenant.slug, range, granularity),
    enabled,
  });
  const dataSufficiency = useQuery({
    ...dataSufficiencyQuery(tenant.slug, range),
    enabled,
  });
  // Campaign markers of the push charts: one page of 100 sent in the period
  // (Assumptions "Marcadores de campanha no gráfico").
  const periodCampaigns = useCampaigns(
    {
      hasBeenSent: 'true',
      launchDateMin: fromDate ?? undefined,
      launchDateMax: toDate ?? undefined,
    },
    100,
    0,
    enabled && Boolean(fromDate && toDate)
  );

  return {
    campaignPerformance,
    campaignOrdersChart,
    dataSufficiency,
    periodCampaigns,
  };
}
